module.exports = __webpack_public_path__ + "img/bg-give.2926ae97.png";